// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto'
import BlipCards from 'blip-cards'
import Vue from 'vue'
import App from './App.vue'
import { store } from './store'
import { AppSettings } from '@/appSettings'
import { applyPolyfills, defineCustomElements } from 'blip-ds/loader'

// Styles
import './assets/scss/main.scss'

// JavaScripts
import { MonitoringErrorHandler } from 'monitoring-error-handler'
import { APPINSIGHTS_CLOUD_COMPONENT_NAME, APPINSIGHTS_INSTRUMENTATION_KEY, SENTRY_DSN } from './settings'

// blip-ds
Vue.config.productionTip = false

Vue.config.ignoredElements = [/bds-\w*/]

applyPolyfills().then(() => {
  defineCustomElements(window)
});

(() => {
  MonitoringErrorHandler.instance.initialize({
    applicationInsights: {
      instrumentationKey: APPINSIGHTS_INSTRUMENTATION_KEY,
      applicationName: APPINSIGHTS_CLOUD_COMPONENT_NAME,
    },
    sentry: AppSettings.get('ENABLE_SENTRY_MONITORING') === 'true'
      ? {
        dsn: SENTRY_DSN,
        environment: AppSettings.get('ENVIRONMENT'),
      }
      : undefined,
  })
})()

// Install blip cards
Vue.use(BlipCards)
Vue.config.productionTip = false

/* eslint-disable no-new */
const instance = new Vue({
  el: '#app',
  store,
  template: '<App/>',
  components: { App },
})



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/main.ts